import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { colors } from '../../../defaultTheme';
import H5 from '../../typography/H5';
import query from '../../../const/mediaQueries';
const Container = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 64px;
  background-color: ${colors.white};
  padding: 0 16px;
  box-sizing: border-box;

  @media ${query.greaterThanMedium} {
    padding: 0 40px;
  }
`;
const Header = styled(H5) `
  margin-left: 10px;
`;
const HeaderContainer = styled.div `
  display: flex;
  align-items: center;
`;
const MultiAccountHeader = ({ id, className, title, icon, addAccountButton }) => {
    return (_jsxs(Container, Object.assign({ id: id, className: className }, { children: [_jsxs(HeaderContainer, { children: [!!icon && icon, _jsx(Header, { children: title })] }), !!addAccountButton && addAccountButton] })));
};
export default MultiAccountHeader;
